import { useEffect, useRef, useState } from 'react';
import { getPathWithRootPath } from '../../../Services/common';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import type {
	restoreElements as RestoreElementsType,
	Excalidraw as ExcalidrawType,
	MainMenu as MainMenuType,
} from '@excalidraw/excalidraw';

export function useExcalidraw() {
	const [excalidrawLib, setExcalidrawLib] = useState<{
		Excalidraw: typeof ExcalidrawType | null;
		MainMenu: typeof MainMenuType | null;
		restoreElements: typeof RestoreElementsType | null;
	}>({ Excalidraw: null, MainMenu: null, restoreElements: null });

	const cssLinkRef = useRef<HTMLLinkElement | null>(null);
	const jsScriptRef = useRef<HTMLScriptElement | null>(null);

	useEffect(() => {
		if (!cssLinkRef.current) {
			cssLinkRef.current = document.createElement('link');

			cssLinkRef.current.rel = 'stylesheet';
			cssLinkRef.current.href = getPathWithRootPath('/dist/libs/excalidraw.index.css');
			cssLinkRef.current.onload = () => {
				console.log('Excalidraw CSS loaded');
			};
			document.head.appendChild(cssLinkRef.current);
		}

		if (window.ExcalidrawLib) {
			console.log('Excalidraw library found in window');
			setExcalidrawLib({
				Excalidraw: window.ExcalidrawLib.Excalidraw,
				MainMenu: window.ExcalidrawLib.MainMenu,
				restoreElements: window.ExcalidrawLib.restoreElements,
			});
			return;
		}

		console.log('Loading Excalidraw library...');

		// Excalidraw depends on React and ReactDOM being available globally (same instance as the application)
		window.React = React;
		window.ReactDOM = ReactDOM;

		jsScriptRef.current = document.createElement('script');
		jsScriptRef.current.src = getPathWithRootPath('/dist/libs/excalidraw.bundle.js');

		jsScriptRef.current.onload = () => {
			console.log('Excalidraw library loaded');
			setExcalidrawLib({
				Excalidraw: window.ExcalidrawLib.Excalidraw,
				MainMenu: window.ExcalidrawLib.MainMenu,
				restoreElements: window.ExcalidrawLib.restoreElements,
			});
		};
		document.body.appendChild(jsScriptRef.current);

		return () => {
			if (jsScriptRef.current) {
				document.body.removeChild(jsScriptRef.current);
			}
			if (cssLinkRef.current) {
				document.head.removeChild(cssLinkRef.current);
			}
		};
	}, []);

	return excalidrawLib;
}
